import API from "serviceshift-ui/api-client";

export default {
  createBatch(_, { link, data }) {
    return API.makeRequest(link, {
      method: "POST",
      data,
    });
  },
  fetchImportVendors({ commit }, link) {
    return API.makeRequest(link, {
      method: "GET",
    }).then((res) => {
      commit("replace", {
        state: "importVendors",
        data: res.data,
      });
    });
  },
  getS3UploadURL(_, { link, filename }) {
    return API.makeRequest(link, {
      method: "POST",
      data: { filename },
    });
  },
  s3Upload(_, { data, file, body }) {
    const formData = new FormData();
    Object.keys(data.parameters).forEach((key) => {
      formData.append(key, data.parameters[key]);
    });
    formData.append("file", file);
    return API.makeRequest(data.server_url, {
      method: "POST",
      data: formData,
      ...body,
    }).then(() => {
      return data.parameters.key;
    });
  },
  fetchImportBatches(_, fetch_batch_url) {
    return API.makeRequest(fetch_batch_url, {
      method: "GET",
    });
  },
  performBatchImport(_, url) {
    return API.makeRequest(url, {
      method: "POST",
    });
  },
  downloadBatchErrors(_, url) {
    return API.makeRequest(url, {
      method: "GET",
    }).then(() => {
      if (url.includes('?')) url += '&download=true';
      else url += '?download=true';
      window.location.href = url;
    });
  }
};
